import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AdminNavbar } from '@core/layout/admin/admin-navbar/admin-navbar';
@Component({
  selector: 'app-admin',
  template: `
    <div class="h-dvh flex flex-col">
      <app-admin-navbar />
      <div
        class="flex-1 lg:pt-30 pt-25 lg:pb-10 pb-5 lg:px-10 px-5 bg-base-200">
        <router-outlet />
      </div>
    </div>
  `,
  imports: [AdminNavbar, RouterOutlet],
})
export class AdminLayout {}
